import { lazy } from "react"
import { Navigate } from "react-router-dom"
import { dir } from './directory'

const FormLogin     = lazy(() => import("../../pages/home/FormLogin"))

const Dashboard     = lazy(() => import("../../pages/dashboard/Dashboard"))
const SoalDetail    = lazy(() => import("../../pages/dashboard/SoalDetail"))
const BiodataDiri   = lazy(() => import("../../pages/dashboard/BiodataDiri"))
const RuangTesFRT   = lazy(() => import("../../pages/ruangtes/RuangTesFRT"))
const RuangTesDISC  = lazy(() => import("../../pages/ruangtes/RuangTesDISC"))
const RuangTesDESK  = lazy(() => import("../../pages/ruangtes/RuangTesDESK"))
const RuangTesIMG   = lazy(() => import("../../pages/ruangtes/RuangTesIMG"))

export const publicRoutes = [
  {
    path: dir()+"/",
    element: <FormLogin />,
  },
  {
    path: dir()+"/login",
    element: <FormLogin />,
  },
  {
    path: dir()+"*",
    element: <Navigate to={`${dir()}/login`} />,
  },
]

export const privateRoutes = [
  {
    path: dir()+"/",
    element: <Dashboard />,
  },
  {
    path: dir()+"/dashboard",
    element: <Dashboard />,
  },
  {
    path: dir()+"/biodata-diri",
    element: <BiodataDiri />,
  },
  {
    path: dir()+"/detail-soal",
    element: <SoalDetail />,
  },
  {
    path: dir()+"/ruang-tes-frt",
    element: <RuangTesFRT />,
  },
  {
    path: dir()+"/ruang-tes-disc",
    element: <RuangTesDISC />,
  },
  {
    path: dir()+"/ruang-tes-deskripsi",
    element: <RuangTesDESK />,
  },
  {
    path: dir()+"/ruang-tes-gambar",
    element: <RuangTesIMG />,
  },
  {
    path: dir()+"*",
    element: <Navigate to={`${dir()}/dashboard`} />,
  },
]